import type { Session } from "next-auth";

/** True when the user has a usable API session (not expired / signed out). */
export function isAuthenticatedSession(
  session: Session | null | undefined,
): boolean {
  if (!session?.user) return false;
  if (session.error === "RefreshTokenExpired") return false;
  if (!session.accessToken) return false;
  return true;
}
